/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionsGetServerIdentityImpact } from "../funcs/remoteSessionsGetServerIdentityImpact.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ServerIdentityImpactResult } from "../models/components/serveridentityimpactresult.js";
import {
  Change,
  GetServerIdentityImpactRequest,
  GetServerIdentityImpactSecurity,
} from "../models/operations/getserveridentityimpact.js";
import { unwrapAsync } from "../types/fp.js";
export type ServerIdentityImpactQueryData = ServerIdentityImpactResult;

export function prefetchServerIdentityImpact(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetServerIdentityImpactRequest,
  security?: GetServerIdentityImpactSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildServerIdentityImpactQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildServerIdentityImpactQuery(
  client$: GramCore,
  request: GetServerIdentityImpactRequest,
  security?: GetServerIdentityImpactSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ServerIdentityImpactQueryData>;
} {
  return {
    queryKey: queryKeyServerIdentityImpact({
      userSessionIssuerId: request.userSessionIssuerId,
      mcpServerId: request.mcpServerId,
      change: request.change,
      providerId: request.providerId,
      clientId: request.clientId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function serverIdentityImpactQueryFn(
      ctx,
    ): Promise<ServerIdentityImpactQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionsGetServerIdentityImpact(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyServerIdentityImpact(
  parameters: {
    userSessionIssuerId: string;
    mcpServerId?: string | undefined;
    change: Change;
    providerId?: string | undefined;
    clientId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "remoteSessions",
    "getServerIdentityImpact",
    parameters,
  ];
}
